<template>
  <div class="flex items-center justify-between">
    <template v-if="content.type === 'link'">
      <div class="flex items-center gap-1 p-0.5">
        <IconBox :icon="icon" />
        <a class="text-primary hover:underline" :href="content.url" target="_blank">{{ content.url }}</a>
      </div>
      <el-tooltip class="p-[14px]" effect="dark" content="Copy" placement="top">
        <button class="text-grayNeutralDark" @click="copyToClipboard(content.url)">
          <i class="el-icon-document-copy"></i>
        </button>
      </el-tooltip>
    </template>
    <!-- CTA text -->
    <template v-if="content.type === 'ctaText'">
      <div class="flex items-center gap-1 p-0.5">
        <IconBox :icon="icon" />
        <span>{{ content.text }}</span>
      </div>
      <el-tooltip class="p-[14px]" effect="dark" content="Copy" placement="top">
        <button class="text-grayNeutralDark" @click="copyToClipboard(content.text)">
          <i class="el-icon-document-copy"></i>
        </button>
      </el-tooltip>
    </template>
    <!-- end -->
    <!-- CTA color -->
    <template v-if="content.type === 'ctaColor'">
      <div class="flex items-center gap-1 p-0.5">
        <div class="p-2 w-5 h-5 rounded" :style="{ background: content.color }"></div>
        <span>{{ content.color }}</span>
      </div>
      <el-tooltip class="p-[14px]" effect="dark" content="Copy" placement="top">
        <button class="text-grayNeutralDark" @click="copyToClipboard(content.color)">
          <i class="el-icon-document-copy"></i>
        </button>
      </el-tooltip>
    </template>
    <!-- end -->
    <!-- image -->
    <template v-if="content.type === 'image'">
      <div class="flex items-center gap-1 p-0.5">
        <template v-if="noImg">
          <img src="@/assets/img/no-image.png" class="w-5 h-5 object-cover rounded-lg border border-grayNeutralLight" />
        </template>
        <template v-else>
          <img :src="imageSignature(content.url)" alt="media" class="w-5 h-5 object-cover rounded-lg" />
        </template>
        <span>{{ content.name }}</span>
      </div>
      <div class="flex items-center justify-between">
        <span class="text-[#909399]">{{ content.size | formatSize }}</span>
        <el-tooltip class="p-[14px]" effect="dark" content="Download" placement="top">
          <a :href="`/api/social-products/social-boost/download/${content.id}`" class="text-black block" download>
            <svg width="16" height="17">
              <use :xlink:href="`#slim-download`"></use>
            </svg>
          </a>
        </el-tooltip>
      </div>
    </template>
    <!-- end -->
    <!-- utm -->
    <template v-if="content.type === 'utm'">
      <div class="flex items-center gap-1 p-0.5">
        <IconBox :icon="icon" />
        <span>{{ content.name }}</span>
      </div>
      <div class="flex items-center justify-between">
        <span class="text-[#909399]">{{ content.size | formatSize }}</span>
        <el-tooltip class="p-[14px]" effect="dark" content="Download" placement="top">
          <a :href="`/api/social-products/social-boost/download/${content.id}`" class="text-black block" download>
            <svg width="16" height="17">
              <use :xlink:href="`#slim-download`"></use>
            </svg>
          </a>
        </el-tooltip>
      </div>
    </template>
    <!-- end -->
  </div>
</template>
<script>
import IconBox from '@/components/social-products/social-boost/parts/IconBox.vue'

export default {
  name: 'AssetCard',
  components: {
    IconBox,
  },
  props: {
    icon: {
      type: String,
      default: '',
    },
    noImg: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      validator: (value) => {
        if (typeof value !== 'object' || value === null) {
          console.error('Content must be an object.')
          return false
        }

        const { type, ...contentValue } = value

        if (!['image', 'link', 'utm', 'ctaText', 'ctaColor'].includes(type)) {
          console.error(`Type '${type}' is invalid.`)
          return false
        }

        switch (type) {
          case 'link':
            if (!('url' in contentValue) || typeof contentValue.url !== 'string') {
              console.error('Link must contain a valid URL.')
              return false
            }
            return true // Validat
          case 'ctaText':
            if (!('text' in contentValue) || typeof contentValue.text !== 'string') {
              console.error('Lipseste textul CTA.')
              return false
            }
            return true // Validat
          case 'ctaColor':
            if (!('color' in contentValue) || typeof contentValue.color !== 'string') {
              console.error('CTA color must be a string.')
              return false
            }
            return true // Validat
          case 'utm':
          case 'image':
            if (
              !('url' in contentValue) ||
              typeof contentValue.url !== 'string' ||
              !('size' in contentValue) ||
              typeof contentValue.size !== 'number' ||
              !('name' in contentValue) ||
              typeof contentValue.name !== 'string'
            ) {
              console.error('Image/UTM must contain a valid URL, size (number), and name (string).')
              return false
            }
            return true // Validat
          default:
            console.error(`The type '${type}' is invalid.`)
            return false // Validat
        }
      },
      required: true,
    },
  },
  filters: {
    formatSize(size) {
      return (size / 1000).toFixed(1) + ' KB'
    },
  },
  methods: {
    actionCta() {
      this.$emit('actionCta', this.content)
    },
    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$message({
            type: 'success',
            message: 'Copied to clipboard.',
          })
        })
        .catch((err) => {
          console.error('Eroare la copiere: ' + err)
        })
    },
    imageSignature(img) {
      // signature image
      return this.signature(img, 'socialproducts', 1)
    },
  },
}
</script>
